import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function SolutionSection() {
  const benefits = ['calmar la ansiedad', 'poner límites', 'procesar el dolor', 'y vivir una vida significativa.'];
  return <section className="py-12 md:py-16 bg-coral text-white relative overflow-hidden" data-id="element-251">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-252"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-dark opacity-10 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-253"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-254">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-255">
          <h2 className="text-2xl md:text-3xl font-medium text-cream mb-8" data-id="element-256">
            ¿Y si este fuera el momento de tomar las riendas de tu salud
            emocional?
          </h2>

          <div className="inline-block bg-white text-coral font-display font-bold text-2xl md:text-4xl px-8 py-4 rounded-2xl shadow-solid mb-8 transform -rotate-1" data-id="element-257">
            🧠 ESTE LIBRO ES MÁS BARATO QUE LA TERAPIA™
          </div>

          <p className="text-xl md:text-2xl font-bold text-cream mb-8" data-id="element-258">
            El Manual Práctico de la Lic. Liz Kelly{' '}
            <br className="hidden md:block" data-id="element-259" />
            <span className="text-gold" data-id="element-260">
              (Libro Digital + 4 Bonos Estratégicos)
            </span>
          </p>

          <p className="text-lg md:text-xl text-cream-dark mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-261">
            Todo explicado con un humor descarado, ingenio inagotable y
            herramientas 100% aplicables para que puedas:
          </p>

          <div className="flex flex-wrap justify-center md:gap-6 gap-[5px]" data-id="element-262">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center gap-2 bg-dark/20 backdrop-blur-sm px-5 py-3 rounded-xl border border-white/10" data-id="element-263">
                <Check className="w-5 h-5 text-gold" data-id="element-264" />
                <span className="font-medium text-lg" data-id="element-265">{benefit}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}